import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './your-contracts-section.component.scss';


interface Agreement {
  handleTenderAgreement: () => void;
  handleContractAgreement: () => void
}

export const YourContractsSection = ({handleTenderAgreement , handleContractAgreement}: Agreement) => {
  const { t } = useTranslation();
  const [expandedProcess, setExpandedProcess] = useState(false);

  return (
    <div className="your-contracts-section">
      <div className="your-contracts-section__header">
        <h2 className="your-contracts-section__title">
          {t('YOUR_CONTRACTS') || 'Your Contracts'}
        </h2>
      </div>

      <div className="your-contracts-section__description">
        <p className="your-contracts-section__description-text">
          {t('CONTRACT_OPTIONS_DESCRIPTION') || 'Choose the option that best fits your working arrangement:'}
        </p>
      </div>

      <div className="your-contracts-section__options-container">
        <div className="your-contracts-section__option-card service-contract">
          <div className="your-contracts-section__option-header">
            <h3 className="your-contracts-section__option-title">
              {t('SERVICE_CONTRACT') || 'Service Contract'}
            </h3>
          </div>
          <div className="your-contracts-section__option-body">
            <p className="your-contracts-section__option-description">
              {t('SERVICE_CONTRACT_DESCRIPTION') || 'Create a service contract between your customer and Invozio that defines scope, period, compensation, and key conditions.'}
            </p>
          </div>
          <div className="your-contracts-section__option-action">
            <button className="your-contracts-section__write-contract-btn" onClick={() => handleContractAgreement()}>
              {t('WRITE_A_CONTRACT') || 'Write a Contract'}
            </button>
          </div>
          <p className="your-contracts-section__option-recommendation">
            {t('RECOMMENDED_FOR_ONGOING_WORK') || 'Recommended for ongoing work'}
          </p>
        </div>

        <div className="your-contracts-section__option-card tender-quotation">
          <div className="your-contracts-section__option-header">
            <h3 className="your-contracts-section__option-title">
              {t('TENDER_QUOTATION') || 'Tender / Quotation'}
            </h3>
          </div>
          <div className="your-contracts-section__option-body">
            <p className="your-contracts-section__option-description">
              {t('TENDER_QUOTATION_DESCRIPTION') || 'Send an offer your customer can sign. A signed quotation works as a simple contract and can help confirm scheduled hours when needed.'}
            </p>
          </div>
          <div className="your-contracts-section__option-action">
            <button className="your-contracts-section__create-tender-btn" onClick={() => handleTenderAgreement()}>
              {t('CREATE_A_TENDER') || 'Create a Tender'}
            </button>
          </div>
          <div className="your-contracts-section__how-it-works-wrapper">
            <button
              className="your-contracts-section__how-it-works-btn"
              onClick={() => setExpandedProcess(!expandedProcess)}
            >
              <span>{t('HOW_IT_WORKS') || 'How it works'}</span>
              {!expandedProcess ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={11}
                  height={6}
                  viewBox="0 0 11 6"
                  fill="none"
                >
                  <path
                    d="M9.83496 0.834961L5.86529 4.80463C5.5724 5.09752 5.09752 5.09752 4.80463 4.80463L0.834961 0.834961"
                    stroke="#6750B8"
                    strokeWidth="1.67"
                    strokeLinecap="round"
                  />
                </svg>

              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={11}
                  height={6}
                  viewBox="0 0 11 6"
                  fill="none"
                >
                  <path
                    d="M0.834961 5.02433L4.80463 1.05466C5.09752 0.761768 5.5724 0.761768 5.86529 1.05466L9.83496 5.02433"
                    stroke="#6750B8"
                    strokeWidth="1.67"
                    strokeLinecap="round"
                  />
                </svg>

              )}
            </button>
          </div>
        </div>
      </div>

      {expandedProcess && (
        <div className="your-contracts-section__process-container">
          <div className="your-contracts-section__process-card">
            <h3 className="your-contracts-section__process-title">
              {t('HOW_TENDER_PROCESS_WORKS') || 'How the Tender Process Works'}
            </h3>

            <div className="your-contracts-section__process-steps">
              <div className="your-contracts-section__process-step">
                <div className="your-contracts-section__step-number">1</div>
                <p className="your-contracts-section__step-text">
                  {t('TENDER_STEP_1') || 'Fill in the quotation fields with what you and your customer agreed.'}
                </p>
              </div>

              <div className="your-contracts-section__process-step">
                <div className="your-contracts-section__step-number">2</div>
                <p className="your-contracts-section__step-text">
                  {t('TENDER_STEP_2')}
                </p>
              </div>

              <div className="your-contracts-section__process-step">
                <div className="your-contracts-section__step-number">3</div>
                <p className="your-contracts-section__step-text">
                  {t('TENDER_STEP_3')}
                </p>
              </div>
            </div>

            <div className="your-contracts-section__process-footer">
              <p className="your-contracts-section__footer-text">
                {t('NEED_HELP') || 'Need help?'} {t('PHONE') || 'Phone:'} <strong>010-494 77 11</strong> ({t('WEEKDAYS_TIME') || 'weekdays 07:00–18:00'}) · {t('EMAIL') || 'Email:'} <strong>support@invozio.com</strong>
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
